import React from 'react';

// Cabeçalho padrão das telas: título + uma linha explicando a tela + ação principal.
// No celular a explicação continua visível (curta) e as ações ficam do lado do título
// quando cabem; senão descem para a linha de baixo ocupando a largura toda.
interface PageHeaderProps {
  title: React.ReactNode;
  description?: React.ReactNode;
  icon?: React.ComponentType<{ className?: string }>;
  actions?: React.ReactNode; // botão principal (e, no máximo, um secundário)
  className?: string;
}

const PageHeader: React.FC<PageHeaderProps> = ({ title, description, icon: Icon, actions, className = '' }) => (
  <div className={`flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 ${className}`}>
    <div className="flex items-start gap-3 min-w-0">
      {Icon && (
        <div className="hidden sm:flex shrink-0 p-2.5 rounded-xl bg-primary-50 text-primary-600 dark:bg-primary-900/30 dark:text-primary-400">
          <Icon className="w-5 h-5" />
        </div>
      )}
      <div className="min-w-0">
        <h1 className="text-xl sm:text-2xl font-bold text-gray-900 dark:text-white leading-tight">{title}</h1>
        {description && (
          <p className="mt-0.5 text-sm text-gray-500 dark:text-gray-400 line-clamp-2">{description}</p>
        )}
      </div>
    </div>
    {actions && <div className="flex items-center gap-2 shrink-0 [&>*]:h-10">{actions}</div>}
  </div>
);

export default PageHeader;
